<template>
    <div>
        <h1>{{ $t('labels.last_entries') }}</h1>

        <div class="row row-scrollable" style="overflow: auto">
            <div class="col col-xs-12 col-sm-12">
                <table class="table table-striped timesheet-entries-table">
                    <thead>
                    <tr>
                        <th v-text="$t('labels.employee')"></th>
                        <th v-text="$t('labels.date')"></th>
                        <th v-text="$t('labels.start')"></th>
                        <th v-text="$t('labels.end')"></th>
                        <th v-text="$t('labels.duration')"></th>
                        <th v-text="$t('labels.team')" v-if="currentDevice.register_activities"></th>
                        <th v-text="$t('labels.activity')" v-if="currentDevice.register_activities"></th>
                        <th v-text="$t('labels.packaging')" v-if="currentDevice.register_activities"></th>
                        <th v-text="$t('labels.row')" v-if="currentDevice.register_activities"></th>
                        <th v-text="$t('labels.row_status')" v-if="currentDevice.register_activities"></th>
                        <th v-text="$t('labels.row_percentage')" v-if="currentDevice.register_activities"></th>
                        <th v-text="$t('labels.amount')" v-if="currentDevice.register_activities"></th>
                        <th></th>
                    </tr>
                    </thead>

                    <tbody v-if="timesheetEntries && timesheetEntries.length">
                    <tr v-for="entry in timesheetEntries" :key="entry.id" :id="'entry-' + entry.id" class="timesheet-entry-row">
                        <td v-text="getEmployeeName(entry)"></td>
                        <td v-text="getDate(entry)"></td>
                        <td v-text="getTime(entry.start)"></td>
                        <td v-text="getTime(entry.end)"></td>
                        <td v-text="getDuration(entry)"></td>
                        <td v-text="entry.team_name" v-if="currentDevice.register_activities"></td>
                        <td v-text="getActivity(entry.activity_id)" v-if="currentDevice.register_activities"></td>
                        <td v-text="getPackaging(entry.packaging)" v-if="currentDevice.register_activities"></td>
                        <td v-text="entry.row_id ? $store.state.rows.find(row => row.id === entry.row_id).title : null" v-if="currentDevice.register_activities"></td>
                        <td v-text="entry.row_status ? $t('statuses.row.' + entry.row_status) : ''" v-if="currentDevice.register_activities"></td>
                        <td v-text="entry.row_percentage ? (entry.row_percentage + '%'): ''" v-if="currentDevice.register_activities"></td>
                        <td v-text="entry.amount" v-if="currentDevice.register_activities"></td>
                        <td class="text-right" width="65">
                            <div class="btn-group">
                                <button class="btn btn-primary btn-sm" @click="$router.push({name: 'edit-entry', params: {id: entry.id}})">
                                    <font-awesome-icon :icon="['fas', 'pen']" />
                                </button>
                                <button class="btn btn-danger btn-sm" @click="deleteEntry(entry)">
                                    <font-awesome-icon :icon="['fas', 'trash']" />
                                </button>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                    <tbody v-else>
                    <tr>
                        <td colspan="13" class="text-center" v-text="$t('labels.no_registrations_yet')"></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="app-actions">
            <div class="col-sm-6"></div>

            <div class="col-sm-6 text-right">
                <button class="btn btn-primary btn--xl" @click="close">{{ $t('labels.close') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'last-entries',

  data() {
    return {
      prevRoute: null
    }
  },

  computed: {
    currentDevice() {
      return this.$store.state.currentDevice;
    },

    timesheetEntries() {
      if (!this.currentDevice) return [];

      let collection = this.currentDevice.register_workdays
          ? this.$store.state.workdays
          : this.$store.state.timesheetEntries;

      if (!collection) collection = [];

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return collection.sort((a, b) => {
        let dtA = a.start ? a.start : a.end;
        let dtB = b.start ? b.start : b.end;


        if (moment(dtA).isAfter(moment(dtB))) return -1;
        if (moment(dtA).isBefore(moment(dtB))) return 1;
        return 0;
      }).slice(0, this.currentDevice.last_entries_amount);
    }
  },

  methods: {
    getEmployeeName(timesheetEntry) {
      let employee = this.$store.state.employees.find(item => item.id === timesheetEntry.employee_id);

      return employee ? employee.name : timesheetEntry.employee_id;
    },

    getDate(timesheetEntry) {
      let date = timesheetEntry.start ? timesheetEntry.start : timesheetEntry.end;

      return date ? moment(date).format('DD-MM-YYYY') : '';
    },

    getTime(timestring, format = true) {
      if (!timestring) return;

      return format ? moment(timestring).format('HH:mm:ss') : moment(timestring);
    },

    getDuration(entry) {
      if (!entry.end) return this.$t('labels.in_progress');

      if (this.currentDevice.register_activities) return entry.duration ? (entry.duration).toString().toHHMMSS() : 0;

      return this.secondsToTime(entry);
    },

    secondsToTime(entry) {
      let start = moment(entry.start);
      let end = moment(entry.end);
      let diff = end.diff(start);

      let hours = Math.floor(diff / 3.6e6);
      let seconds = Math.floor((diff % 6e4) / 1000);
      let minutes = Math.floor((diff % 3.6e6) / 6e4);

      return hours + ':' + minutes + ':' + seconds;
    },

    getActivity(activityId) {
      if (!activityId) return;

      let activity = this.$store.state.activities.find(item => item.id === activityId);

      return activity ? activity.name : '';
    },

    getPackaging(packagingId) {
      if (!packagingId) return;

      let packaging = this.$store.state.packagings.find(item => item.id === packagingId);

      return packaging ? packaging.name : '';
    },

    deleteEntry(entry) {
      if (confirm(this.$t('messages.delete_registration'))) {
        if (this.currentDevice.register_activities) this.$store.dispatch('deleteTimesheetEntry', entry);
        else this.$store.dispatch('deleteWorkday', entry)
      }
    },

    close() {
      let navbar = this.$parent.$children.find(item => item.$options.name === 'navbar');

      if (!navbar) return this.$router.go(-1);

      return window.setTimeout(() => this.$router.go(this.prevRoute.name === 'edit-entry' ? -3 : -1), 300);

    }
  },

  mounted() {
    window.events.$emit('disableNumpad');

    if (
        (this.$store.getters.currentEmployee === null || this.$store.getters.currentEmployee === undefined) &&
        this.currentDevice &&
        this.currentDevice.register_activities
    ) {
      this.$router.push({name: 'pin'});
    }

    let main = document.querySelector('.app-main');
    let sidebar = document.querySelector('.app-sidebar');

    main.classList.add('app-main--fullscreen');
    sidebar.style.display = 'none';

    window.events.$emit('setFullscreen', true);
  },

  beforeDestroy() {
    window.events.$emit('setFullscreen', false);

    let main = document.querySelector('.app-main');
    let sidebar = document.querySelector('.app-sidebar');

    main.classList.remove('app-main--fullscreen');
    sidebar.style.display = 'flex';
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    });
  }
}
</script>

<style scoped>
    .actions--fixed {
        height: calc(100% - 40px);
    }

    .actions--fixed > div {
        overflow: scroll;
    }
</style>
